export const weekDays = [
  {
    label: 'Monday',
    value: 'Mon'
  },
  {
    label: 'Tuesday',
    value: 'Tues'
  },
  {
    label: 'Wednesday',
    value: 'Wed'
  },
  {
    label: 'Thursday',
    value: 'Thurs'
  },
  {
    label: 'Friday',
    value: 'Fri'
  },
  {
    label: 'Saturday',
    value: 'Sat'
  },
  {
    label: 'Sunday',
    value: 'Sun'
  }
];

export const courseAvailableDomains = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'International (.com)',
    value: 'international'
  },
  {
    label: 'Philippines (.ph)',
    value: 'philippines'
  }
];

export const communityPlatforms = [
  { label: 'Whatsapp', value: 'whatsapp' },
  { label: 'Discord', value: 'discord' }
];

export const nullCourseOption = {
  label: 'NO COURSE',
  value: null
};

export const dayOfWeekMap = {
  Mon: 0,
  Tues: 1,
  Wed: 2,
  Thurs: 3,
  Fri: 4,
  Sat: 5,
  Sun: 6
};

export const dayOfWeekMapInverse = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tues',
  3: 'Wed',
  4: 'Thurs',
  5: 'Fri',
  6: 'Sat'
};
export const conditionalOptions = [
  {
    label: 'true',
    value: true
  },
  {
    label: 'false',
    value: false
  }
];

export const type = {
  NUMBER: 'Number',
  STRING: 'String',
  DATE: 'Date'
};

export const monthIndexMap = {
  0: 'Jan',
  1: 'Feb',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
};

export const GENERIC_ERROR_MESSAGE =
  'Getting response from the backend failed!';

export const IDLE_STATUS_MESSAGE = 'In idle mode';
export const SUCCESS_MESSAGE = 'Successful!';

// state status
export const IDLE = 'IDLE';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export const REQUEST_RETRACT_SUCCESS = 'REQUEST_RETRACT_SUCCESS';

// custom messages
export const REQUEST_RETRACT_SUCCESS_MESSAGE =
  'Wave retract request sent!';

export const COURSE_OFFER_TYPES = {
  LIVE: 'live',
  COHORT_LIVE: 'cohortLive',
  PRE_RECORDED: 'preRecorded',
  VIDEO_ON_DEMAND: 'videoOnDemand',
  COHORT_ON_DEMAND: 'cohortOnDemand',
  FREE_WORKSHOP: 'freeWorkshop'
};

export const ONDEMAND_COURSE_OFFER_TYPES = [
  COURSE_OFFER_TYPES.PRE_RECORDED,
  COURSE_OFFER_TYPES.VIDEO_ON_DEMAND,
  COURSE_OFFER_TYPES.COHORT_ON_DEMAND
];

export const COURSE_TYPES = {
  LIVE: 'live',
  COHORT_LIVE: 'cohortlive',
  ON_DEMAND: 'ondemand',
  VIDEO_ON_DEMAND: 'videoondemand',
  COHORT_ON_DEMAND: 'cohortondemand',
  FREE_WORKSHOP: 'freeworkshop'
};

export const ONDEMAND_COURSE_TYPES = [
  COURSE_TYPES.ON_DEMAND,
  COURSE_TYPES.VIDEO_ON_DEMAND,
  COURSE_TYPES.COHORT_ON_DEMAND
];

export const COHORT_TYPES = [
  COURSE_TYPES.COHORT_LIVE,
  COURSE_TYPES.COHORT_ON_DEMAND
];

export const COHORT_OFFER_TYPES = [
  COURSE_OFFER_TYPES.COHORT_LIVE,
  COURSE_OFFER_TYPES.COHORT_ON_DEMAND
];

export const thresholdImageSize = 5;

export const customCards = [
  'meet-facilitator',
  'meet-creator-note',
  'join-community',
  'qna',
  'graduation',
  'feedback',
  'meet-creator',
  'reminder',
  'launch-party',
  'custom-live-session'
];

export const cusotmLiveSessionCards = [
  'launch-party',
  'custom-live-session',
  'meet-creator',
  'qna',
  'graduation'
];

export const formTitleMap = {
  'launch-party': 'Launch Party',
  'custom-live-session': 'Live Session',
  qna: 'MYC',
  graduation: 'Graduation',
  'meet-creator': 'Meet Creator'
};
